import { SETTINGS_LIMITED_ROUTE } from '@config/tenantRestrictions';

export type SettingsRootStack = 'Settings' | typeof SETTINGS_LIMITED_ROUTE;

export const isLimitedSettingsStack = (rootStack: SettingsRootStack | undefined): boolean =>
  rootStack === SETTINGS_LIMITED_ROUTE;

export const buildSettingsNavParams = (
  rootStack: SettingsRootStack,
  section: string,
  screen: string = section,
  params?: Record<string, unknown>,
) =>
  isLimitedSettingsStack(rootStack)
    ? { screen, ...(params ? { params } : {}) }
    : { screen: section, params: { screen, ...(params ? { params } : {}) } };
